var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-modal',{attrs:{"visible":_vm.wordDialog,"footer":null,"layout":_vm.formLayout,"closable":false,"maskClosable":true},on:{"cancel":_vm.close}},[_c('div',{staticClass:"word"},[_c('img',{attrs:{"src":"https://resource.51beauty.com.cn/735597e2-04e7-4324-a56c-f7b9239c5d13?imageslim","alt":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }